import React, { useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { iconDemo } from "utils/constants";
import AppModal from "components/ui/AppModal/AppModal";
// import loginBackVideo from "assets/images/VídeoBackGround.mp4";
import styles from "./auth.module.css";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const { token } = useParams();
  const navigate = useNavigate();
  const [feedbackModal, setFeedbackModal] = useState({
    open: false,
    variant: "custom",
    title: "",
    message: "",
    confirmText: "OK"
  });
  const [afterConfirmRoute, setAfterConfirmRoute] = useState(null);

  const closeFeedbackModal = () =>
    setFeedbackModal(prev => ({ ...prev, open: false }));

  const handleConfirm = () => {
    closeFeedbackModal();
    if (afterConfirmRoute) {
      const route = afterConfirmRoute;
      setAfterConfirmRoute(null);
      navigate(route);
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setFeedbackModal({
        open: true,
        variant: "error",
        title: "Erro!",
        message: "As senhas não coincidem."
      });
      return;
    }
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/users/reset-password?token=${token}&new_password=${password}`
      );
      setAfterConfirmRoute("/login");
      setFeedbackModal({
        open: true,
        variant: "success",
        title: "Sucesso!",
        message: response.data.message,
        confirmText: "OK"
      });
    } catch (error) {
      setFeedbackModal({
        open: true,
        variant: "error",
        title: "Erro!",
        message: "Erro ao redefinir a senha."
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.root}>
{/* <video autoPlay muted loop className={styles.videoBg}>
        <source src={loginBackVideo} type="video/mp4" />
      </video> */}
      <div className={styles.overlay} />

      <div className={styles.card}>
        <div className={styles.logoWrap}>
          <img src={iconDemo} alt="Vertex4D" className={styles.logo} />
        </div>
        <h1 className={styles.title}>Redefinir Senha</h1>
        <p className={styles.subtitle}>Escolha uma nova senha segura para sua conta.</p>

        <form onSubmit={handleSubmit} noValidate>
          <div className={styles.formGroup}>
            <label className={styles.label}>Nova Senha</label>
            <div className={styles.inputGroup}>
              <input
                type={showPassword ? "text" : "password"}
                className={styles.input}
                placeholder="••••••••"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
              />
              <div
                className={styles.inputGroupAppend}
                onClick={() => setShowPassword(!showPassword)}
              >
                <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
              </div>
            </div>
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>Confirme a Nova Senha</label>
            <div className={styles.inputGroup}>
              <input
                type={showConfirm ? "text" : "password"}
                className={styles.input}
                placeholder="••••••••"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                required
              />
              <div
                className={styles.inputGroupAppend}
                onClick={() => setShowConfirm(!showConfirm)}
              >
                <i className={`fa ${showConfirm ? "fa-eye-slash" : "fa-eye"}`} />
              </div>
            </div>
          </div>

          <button
            type="submit"
            className={`${styles.btn} ${styles.btnPrimary}`}
            disabled={loading}
          >
            {loading ? <><div className={styles.spinner} /> Redefinindo...</> : "Redefinir Senha"}
          </button>
        </form>

        <p className={styles.linkRow}>
          <button className={styles.link} onClick={() => navigate("/login")}>
            Voltar ao login
          </button>
        </p>
      </div>

      <AppModal
        isOpen={feedbackModal.open}
        onClose={closeFeedbackModal}
        allowOutsideClick={true}
        variant={feedbackModal.variant}
        title={feedbackModal.title}
        message={feedbackModal.message}
        confirmText={feedbackModal.confirmText}
        cancelText={null}
        onConfirm={handleConfirm}
        onCancel={closeFeedbackModal}
      />
    </div>
  );
};

export default ResetPassword;
